import { NavigableButton } from '@carvana/ds-button';
import Link from '@carvana/ds-link';
import breakpoints from '@carvana/merch-tailwind/breakpoints';
import { appAssetsCdnUrl } from '~/constants/environment';
import { type NewCarVariant } from '~/utilities/srp/new-car/getNewCarVariant';
import { Wrapper } from '../PromoBanner.styles';

type OwnProps = {
  bannerName: string;
  href: string;
  variant: NewCarVariant;
};

const backgroundDesktopSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-desktop.svg`;
const backgroundMobileSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-mobile.svg`;
const backgroundTabletSrc = `${appAssetsCdnUrl}/images/helios/promoBanners/ncc/generic/background-tablet.svg`;

export default function GenericBanner({ bannerName, href, variant }: OwnProps) {
  const shopAnalyticsAttributes = JSON.stringify({
    category: bannerName,
    label: 'Select Color, Options & More',
    variant
  });

  return (
    <Wrapper className="bg-background-muted-subtle">
      <picture aria-hidden="true">
        <source
          media={`(min-width: ${breakpoints.lg}px)`}
          srcSet={backgroundDesktopSrc}
        />
        <source
          media={`(min-width: ${breakpoints.sm}px)`}
          srcSet={backgroundTabletSrc}
        />
        <img
          alt=""
          className="absolute inset-0 size-full"
          src={backgroundMobileSrc}
        />
      </picture>

      <div className="relative z-1 flex flex-1 flex-col justify-center gap-xl sm:gap-lg py-2xl pl-2xl sm:pr-0 lg:py-4xl lg:pl-4xl xl:h-[176px]">
        <h4 className="t-brand-xs max-w-[290px] text-text-inverse sm:max-w-[350px] md:max-w-[290px] lg:t-brand-sm lg:max-w-[510px] xl:max-w-full">
          discover <span className="text-yellow-400">new car</span> shopping
        </h4>
        <p className="hidden max-w-[348px] t-body-sm text-text-inverse sm:block lg:max-w-[450px] xl:max-w-full">
          Build your perfect ride — pickup or delivery as soon as today!
        </p>
        <div className="sm:hidden">
          <Link
            className="text-text-inverse"
            data-adobe-id="select-color-options-more"
            data-analytics-attributes={shopAnalyticsAttributes}
            data-analytics-id="Banner"
            data-testid="promo-banner-select-color-options-more"
            href={href}
            size="sm"
          >
            Select Color, Options & More
          </Link>
        </div>
      </div>

      <div className="relative z-1 hidden shrink-0 items-center justify-center px-4xl sm:flex md:pr-2xl lg:px-5xl">
        <NavigableButton
          data-adobe-id="select-color-options-more"
          data-analytics-attributes={shopAnalyticsAttributes}
          data-analytics-id="Banner"
          href={href}
          size="md"
          variant="primary"
        >
          Select Color, Options & More
        </NavigableButton>
      </div>
    </Wrapper>
  );
}
